<template>
  <div class="app flex-row align-items-center login-bg">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4" style="margin: 0 auto">
              <form class="card-block" @submit.prevent="login" style="position: relative;">
                <i class="fa fa-times" style="color: #000; position: absolute; top: 0px; right: 0px;cursor: pointer;" v-if="$session.showLogin" @click="$session.showLogin = false"></i>
                <h1>Log In</h1>
                <p class="text-muted" v-if="forgot">Reset your password</p>
                <p class="text-muted" v-else>Sign In to your account</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon" style="width: 43px;"><i class="fa fa-user"></i></span>
                  <input type="email" v-model="email" class="form-control" placeholder="Email">
                </div>
                <div class="input-group mb-4" v-if="!forgot">
                  <span class="input-group-addon" style="width: 43px"><i class="fa fa-key"></i></span>
                  <input type="password" v-model="password" class="form-control" placeholder="Password">
                </div>
                <div class="row" v-if="error">
                  <div class="col-12">
                    <div class="alert alert-danger">{{error}}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <button role="button" type="submit" class="btn btn-primary px-4">{{forgot ? 'Continue' : 'Log In'}} <i class="fa fa-spinner fa-spin" v-if="loading"></i></button>
                  </div>
                  <div class="col-6 text-right">
                    <button v-if="forgot" role="button" type="button" class="btn btn-link px-0" @click="forgot = false">Nevermind</button>
                    <button v-else role="button" type="button" class="btn btn-link px-0" @click="forgot = true">Forgot password?</button>
                  </div>
                </div>
              </form>
            </div>
            <!--
            <div class="card card-inverse card-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-block text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Click below to create a new account.</p>
                  <button type="button" class="btn btn-primary active mt-3">Register Now!</button>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.login-bg {
  background-color: rgba(228, 229, 230, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  z-index: 1000;
}
</style>

<script>
const axios = require('axios')
const property = require('lodash/property')

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      error: '',
      email: '',
      password: '',
      forgot: false
    }
  },
  created () {
    this.email = localStorage.email || ''
  },
  methods: {
    forgot () {
      window.alert('TODO')
    },
    login () {
      if (this.loading) {
        return
      }
      this.error = ''
      if (!this.email) {
        this.error = 'Please enter an email address.'
        return
      }
      if (this.forgot) {
        return this.forgot()
      }
      if (!this.password) {
        this.error = 'Please enter a password.'
        return
      }
      this.loading = true
      axios({
        method: 'POST',
        url: '/rest/token',
        auth: {
          username: this.email,
          password: this.password
        }
      }).then((response) => {
        // Extract the token from the response and pull the user data
        window.localStorage.setItem('token', response.data.token)
        if (response.data.refresh_token) {
          window.localStorage.setItem('refresh_token', response.data.refresh_token)
        }
        window.localStorage.setItem('email', this.email) // Temporary
        return this.$session.getUser()
      }).catch((response) => {
        if (property('error.data.error')(response)) {
          this.error = response.error.data.error
        } else {
          this.error = 'Unable to log in with those credentials.'
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?01a5353d